import React, { useState, useEffect, useRef } from "react";
import AuditActions from "../../Actions/AuditActions";
import UserManagementActions from "../../Actions/UserManagementActions";
import AuditConstants from "../../Constants/AuditConstants";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { AiOutlineFolderView } from "react-icons/ai";
import { MdOutlineTimeline, MdViewList } from "react-icons/md";
import auditStore from "../../Stores/AuditStores";
import usermanagementStore from "../../Stores/UsermanagementStore";
import AuditFieldLog from "./AuditFieldLog";
import AuditObjectLog from "./AuditObjectLog";
import DatePicker from "react-datepicker";
import TypeAhead from "../AddRole/TypeAhead";
import { useSelectedConfigActionContext } from "../../Context/GlobalContext";
import { PageHeader } from "../MuiOverRideComponent/PageHeader";

function defaultDate() {
  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 7);

  return currentDate;
}

function Audit() {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const currentDate = new Date();
  const [showTabelRow, setShowTabelRow] = useState(false);
  const [showSecondTable, setShowSecondTable] = useState(false);
  const [plantList, setPlantList] = useState([]);
  const [plantId, setPlantId] = useState("");
  const [operationAuditList, setOperationAuditList] = useState([]);
  const [operationAuditLogList, setOperationAuditLogList] = useState([]);
  const [fieldLog, setFieldLog] = useState("");
  const [objectLog, setobjectLog] = useState("");
  const [startDate, setStartDate] = useState(defaultDate());
  const [startDateObj, setStartDateObj] = useState({
    year: 0,
    month: 0,
    day: 0,
  });
  const [endDate, setEndDate] = useState(currentDate);
  const [endDateObj, setEndDateObj] = useState({
    year: 0,
    month: 0,
    day: 0,
  });
  const [operationList, setOperationList] = useState([]);
  const [opertaionId, setOpertaionId] = useState("");
  const [entityList, setEntityList] = useState([]);
  const [entityId, setEntityId] = useState(0);
  const [searchtext, setSearchText] = useState([]);
  const [searchInfo, setSearchInfo] = useState("");
  const [searchInfoPlaceHolder, setSearchInfoPlaceHolder] = useState("");
  const [userID, setUserID] = useState("");
  const typeHeadRef = useRef("");
  const updateSelectedConfig = useSelectedConfigActionContext();
  const previousSearchUserRef = useRef("");

  useEffect(() => {
    if (endDate !== "" && endDate !== null) {
      const day = endDate.getDate();
      const month = endDate.getMonth() + 1;
      const year = endDate.getFullYear();
      setEndDateObj({
        year: year,
        month: month,
        day: day,
      });
    } else {
      setEndDateObj({
        year: 0,
        month: 0,
        day: 0,
      });
    }
  }, [endDate]);

  useEffect(() => {
    setSearchInfo("");
  }, [entityId]);

  /* <>--------------------------------------------------------------------Handle Entity change Start----------------------------------------------------------<> */
  useEffect(() => {
    entityList.map((item) => {
      if (item.id === parseInt(entityId)) {
        setSearchInfoPlaceHolder(item.text);
        switch (item.text) {
          case "Equipment":
            setSearchInfoPlaceHolder(localization.inventanrnr);
            break;
          case "Equipment Group":
            setSearchInfoPlaceHolder(localization.designation);
            break;
          case "Manufacturer":
            setSearchInfoPlaceHolder(localization.manufacturer);
            break;
          case "Detail Feedback":
            setSearchInfoPlaceHolder(localization.detailedFeedback);
            break;
        }
      }
    });
  }, [entityId]);
  /* <>--------------------------------------------------------------------Handle Entity change End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Handle Plant change Start----------------------------------------------------------<> */
  useEffect(() => {
    if (plantId !== "") {
      setUserID("");
      setSearchText([]);
      previousSearchUserRef.current = "";
      typeHeadRef.current.resetTypeHead();
    }
  }, [plantId]);

  /* <>--------------------------------------------------------------------Handle Plant change End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Get Plant Start----------------------------------------------------------<> */
  useEffect(() => {
    setGlobalSpinner(true);
    UserManagementActions.getPlantsByUserId();
    function getPlantSuccess() {
      var res = usermanagementStore.getPlantResult();
      if (res.length > 0) {
        setPlantList(res);
        setPlantId(res[0].id);
      } else {
        setPlantList([]);
        setPlantId("");
      }
      setGlobalSpinner(false);
    }

    function getPlantFailure() {
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure
    );
    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get Plant End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Get  Operation Log Start----------------------------------------------------------<> */
  useEffect(() => {
    function getOperationAuditSuccess() {
      setShowSecondTable(false);
      var res = auditStore.getOperationAudit();
      if (res.length > 0) {
        setOperationAuditList(res);
        setShowTabelRow(true);
        setGlobalSpinner(false);
      } else {
        setOperationAuditList([]);
        setShowTabelRow(true);
        setGlobalSpinner(false);
      }
    }

    function getOperationAuditFailure() {
      setOperationAuditList([]);
      setShowTabelRow(true);
      setShowSecondTable(false);

      setGlobalSpinner(false);
    }

    auditStore.addChangeListener(
      AuditConstants.GET_OPERATION_AUDIT_SUCCESS,
      getOperationAuditSuccess
    );

    auditStore.addChangeListener(
      AuditConstants.GET_OPERATION_AUDIT_FAILURE,
      getOperationAuditFailure
    );
    return () => {
      auditStore.removeChangeListener(
        AuditConstants.GET_OPERATION_AUDIT_SUCCESS,
        getOperationAuditSuccess
      );

      auditStore.removeChangeListener(
        AuditConstants.GET_OPERATION_AUDIT_FAILURE,
        getOperationAuditFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get  Operation Log End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Get Audit  Log Start----------------------------------------------------------<> */
  useEffect(() => {
    function getAuditLogSuccess() {
      setOperationAuditLogList([]);
      var res = auditStore.getOperationAuditLog();
      if (res.length > 0) {
        setOperationAuditLogList(res);
        setShowSecondTable(true);
        setGlobalSpinner(false);
      } else {
        setOperationAuditLogList([]);
        setShowSecondTable(true);
        setGlobalSpinner(false);
      }
    }

    function getAuditLogFailure() {
      setGlobalSpinner(false);
    }

    auditStore.addChangeListener(
      AuditConstants.GET_OPERATION_AUDIT_LOG_SUCCESS,
      getAuditLogSuccess
    );

    auditStore.addChangeListener(
      AuditConstants.GET_OPERATION_AUDIT_LOG_FAILURE,
      getAuditLogFailure
    );
    return () => {
      auditStore.removeChangeListener(
        AuditConstants.GET_OPERATION_AUDIT_LOG_SUCCESS,
        getAuditLogSuccess
      );

      auditStore.removeChangeListener(
        AuditConstants.GET_OPERATION_AUDIT_LOG_FAILURE,
        getAuditLogFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get Audit  Log End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Get Search Field Start----------------------------------------------------------<> */
  useEffect(() => {
    AuditActions.getSearchField();
    function getSearchFieldSuccess() {
      var res = auditStore.getsearchField();

      if (res) {
        setOperationList(res.operations);
        setEntityList(res.entites);
        setOpertaionId("");
        setEntityId(0);
        setGlobalSpinner(false);
      } else {
        setOperationList([]);
        setEntityList([]);
        setOpertaionId([]);
        setEntityId(0);
        setGlobalSpinner(false);
      }
      updateSelectedConfig("");
    }

    function getSearchFieldFailure() {
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    auditStore.addChangeListener(
      AuditConstants.GET_SEARCH_FIELD_SUCCESS,
      getSearchFieldSuccess
    );

    auditStore.addChangeListener(
      AuditConstants.GET_SEARCH_FIELD_FAILURE,
      getSearchFieldFailure
    );

    return () => {
      auditStore.removeChangeListener(
        AuditConstants.GET_SEARCH_FIELD_SUCCESS,
        getSearchFieldSuccess
      );

      auditStore.removeChangeListener(
        AuditConstants.GET_SEARCH_FIELD_FAILURE,
        getSearchFieldFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get Search Field End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Get User By Plant  Start----------------------------------------------------------<> */
  useEffect(() => {
    function getUserByPlantIdSuccess() {
      var res = usermanagementStore.getUsersByResult();
      let userList = [];
      if (res.length > 0) {
        res.map((item) => {
          userList.push({
            id: item.id,
            label: item.text,
          });
        });
        setSearchText(userList);
        setGlobalSpinner(false);
      } else {
        setSearchText([]);
        setGlobalSpinner(false);
      }
    }

    function getUserByPlantIdFailure() {
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_USER_SUCCESS,
      getUserByPlantIdSuccess
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_USER_FAILURE,
      getUserByPlantIdFailure
    );
    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_USER_SUCCESS,
        getUserByPlantIdSuccess
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_USER_FAILURE,
        getUserByPlantIdFailure
      );
    };
  }, []);
  /* <>--------------------------------------------------------------------Get User By Plant  End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Button Render  Start----------------------------------------------------------<> */
  function RenderViewButton(props) {
    const id = props.id;
    return (
      <AiOutlineFolderView
        className="mr-4 cursorPoint svgIcon"
        title={localization.viewDetail}
        size={20}
        onClick={() => {
          setGlobalSpinner(true);
          AuditActions.getOperationAuditLog(id);
        }}
      />
    );
  }

  function RenderTimeLineButton(props) {
    const fieldInfo = {
      fieldId: props.fieldId,
      fieldName: props.field,
      auditObjectLogId: props.auditObjectLogId,
    };

    return (
      <MdOutlineTimeline
        className="mr-4 cursorPoint svgIcon"
        title={localization.fieldView}
        data-toggle="modal"
        data-target="#auditFieldLog"
        size={20}
        onClick={() => {
          setGlobalSpinner(true);
          setFieldLog(fieldInfo);
        }}
      />
    );
  }

  function RenderObjectLogButton(props) {
    const auditObjectLogId = props.auditObjectLogId;

    return (
      <MdViewList
        className="mr-4 cursorPoint svgIcon"
        title={localization.entityView}
        data-toggle="modal"
        data-target="#auditObjectLog"
        size={20}
        onClick={() => {
          setGlobalSpinner(true);
          setobjectLog(auditObjectLogId);
        }}
      />
    );
  }
  /* <>--------------------------------------------------------------------ButtosetStartDateObjn Render  End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Handle Search button Click  Start----------------------------------------------------------<> */
  function handleAuditSearch(e) {
    e.preventDefault();
    setOperationAuditList([]);
    const searchField = {
      PlantId: plantId,
      OperationId: parseInt(opertaionId),
      UserId: userID === "" ? null : userID,
      FromDate: startDateObj,
      ToDate: endDateObj,
      AuditForId: entityId === 0 ? null : parseInt(entityId),
      Token: searchInfo,
    };
    setGlobalSpinner(true);
    AuditActions.getOperationAudit(searchField);
  }
  /* <>--------------------------------------------------------------------Handle Search button Click  Start----------------------------------------------------------<> */
  function handleCloseAuditObjectLog() {
    setobjectLog("");
  }
  /* <>--------------------------------------------------------------------Handle Date Picker  Start----------------------------------------------------------<> */
  useEffect(() => {
    if (startDate !== "" && startDate !== null) {
      const day = startDate.getDate();
      const month = startDate.getMonth() + 1;
      const year = startDate.getFullYear();
      if (currentDate > startDate) {
        setEndDate(currentDate);
      } else {
        setEndDate("");
      }

      setStartDateObj({
        year: year,
        month: month,
        day: day,
      });
    } else {
      setStartDateObj({
        year: 0,
        month: 0,
        day: 0,
      });
    }
  }, [startDate]);

  /* <>--------------------------------------------------------------------Handle Date Picker  End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Handle Type Head Start----------------------------------------------------------<> */
  function typeAheadInputChangeCallback(text) {
    if (text.length > 2) {
      if (previousSearchUserRef.current.toLowerCase() !== "") {
        if (
          !text
            .toLowerCase()
            .startsWith(previousSearchUserRef.current.toLowerCase())
        ) {
          previousSearchUserRef.current = text;
          setGlobalSpinner(true);
          UserManagementActions.getPlantUser(text, plantId);
        }
      } else {
        previousSearchUserRef.current = text;
        setGlobalSpinner(true);
        UserManagementActions.getPlantUser(text, plantId);
      }
    }
  }

  function typeAheadSelectedCallback(selectedList) {
    if (selectedList && selectedList.length > 0) {
      setUserID(selectedList[0].id);
    }
  }
  function handleSelectedItem() {
    setUserID("");
  }

  /* <>--------------------------------------------------------------------Handle Type Head  End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Handle Reset  Start----------------------------------------------------------<> */
  function handleReset(e) {
    e.preventDefault();
    setOpertaionId("");
    setEntityId(0);
    setSearchInfo("");
    setPlantId(plantList[0].id);
    setStartDate(defaultDate());
    setEndDate(currentDate);
    typeHeadRef.current.resetTypeHead();
  }
  /* <>--------------------------------------------------------------------Handle Reset End----------------------------------------------------------<> */

  return (
    <>
      <div id="content">
        <div className="pt-4  d-flex justify-content-between">
          <PageHeader
            Title={localization.genSetting + " / " + localization.auditDetails}
          />

          <div className="d-flex justify-content-between"></div>
        </div>
        <form id="searchPanel" name="searchPanel" onSubmit={handleAuditSearch}>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label htmlFor="operationList" className="mr-3">
                  {localization.operation}
                </label>
                <select
                  className="form-control"
                  id="operationList"
                  name="operationList"
                  value={opertaionId}
                  onChange={(e) => {
                    setOpertaionId(e.target.value);
                  }}
                >
                  <option value="">{localization.all}</option>
                  {operationList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.text}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-2 pl-0">
              <div className="form-group  align-items-center">
                <label htmlFor="plantList" className="mr-3">
                  {localization.plant}
                </label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  value={plantId}
                  onChange={(e) => {
                    setPlantId(e.target.value);
                  }}
                >
                  {plantList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {`${row.bezeichnung} (${row.plantID})`}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col-2 pl-0">
              <div>
                <div className="auditTypeHeadLabel">
                  <label htmlFor="user" className="mr-3">
                    {localization.users}
                  </label>
                </div>
                <TypeAhead
                  typeAheadInputChangeCallback={typeAheadInputChangeCallback}
                  typeAheadSelectedCallback={typeAheadSelectedCallback}
                  isMultiple={false}
                  ref={typeHeadRef}
                  searchedList={searchtext}
                  resetSelectedItem={handleSelectedItem}
                />
              </div>
            </div>
            <div className="col pl-0">
              <div className="form-group">
                <label htmlFor="startDate" className="mr-3">
                  {localization.From}
                </label>

                <DatePicker
                  className="form-control"
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                  }}
                  dateFormat="dd.MM.yyyy"
                  placeholderText={localization.enterStartDate}
                  required
                  maxDate={currentDate}
                />
              </div>
            </div>
            <div className="col pl-0">
              <div className="form-group">
                <label htmlFor="endDate" className="mr-3">
                  {localization.to}
                </label>
                <DatePicker
                  className="form-control"
                  selected={endDate}
                  disabled={startDate === ""}
                  onChange={(date) => {
                    setEndDate(date);
                  }}
                  startDate={startDate}
                  minDate={startDate}
                  maxDate={currentDate}
                  placeholderText={localization.enterEndDate}
                  dateFormat="dd.MM.yyyy"
                  required
                />
              </div>
            </div>
            <div className="col pl-0">
              <div className="form-group">
                <label htmlFor="entityList" className="mr-3">
                  {localization.dataEntity}
                </label>
                <select
                  className="form-control"
                  id="entityList"
                  name="entityList"
                  value={entityId}
                  onChange={(e) => {
                    setEntityId(parseInt(e.target.value));
                  }}
                >
                  <option value={0}>
                    {`${localization.select} ${localization.dataEntity}`}
                  </option>
                  {entityList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.text}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="col pl-0">
              <div className="form-group">
                <label htmlFor="plantList" className="mr-3">
                  {localization.search}
                </label>
                <input
                  type="text"
                  id="searchInfo"
                  name="searchInfo"
                  className="form-control"
                  disabled={entityId === 0}
                  placeholder={
                    entityId === 0 ? "" : `Enter ${searchInfoPlaceHolder}`
                  }
                  value={searchInfo}
                  onChange={(e) => {
                    setSearchInfo(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col mt-5 d-flex pl-0">
              <div className="form-group  align-items-center">
                <button type="submit" className="btn btn-primary">
                  {localization.search}
                </button>
              </div>
              <div className="form-group  align-items-center ml-1">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleReset}
                >
                  {localization.reset}
                </button>
              </div>
            </div>
          </div>
        </form>
        <div className="container-fluid p-0 m-0 mt-3">
          {showTabelRow && (
            <div className="row">
              <div className="col-6 pl-0 ">
                <h2 className="ml-3">{localization.operationLog}</h2>
                <div className="table-responsive px-3 auditTabelHeig">
                  <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                    <thead className="bg-light">
                      <tr>
                        <th>{localization.operation}</th>
                        <th>{localization.performedBy}</th>
                        <th>{localization.performedOn}</th>
                        <th>{localization.action}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {operationAuditList.length > 0 ? (
                        <>
                          {operationAuditList.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{item.operation}</td>
                                <td>{item.user}</td>
                                <td>{item.updatedOn}</td>
                                <td>
                                  <RenderViewButton id={item.id} />
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td className="text-center" colSpan={100}>
                              <p>{localization.noRecordFound}</p>
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {showSecondTable && (
                <div className="col-6 pl-0 ">
                  <h2 className="ml-3">{localization.operationDetailsLog}</h2>
                  <div className="table-responsive px-3 auditTabelHeig">
                    <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                      <thead className="bg-light">
                        <tr>
                          <th>{localization.dataEntity}</th>
                          <th>{localization.identifier}</th>
                          <th>{localization.field}</th>
                          <th>{localization.oldValue}</th>
                          <th>{localization.newValue}</th>
                          <th>{localization.action}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {operationAuditLogList.length > 0 ? (
                          <>
                            {operationAuditLogList.map((item, i) => {
                              return (
                                <tr key={i}>
                                  <td>{item.auditOf}</td>
                                  <td>{item.identifer}</td>
                                  <td>{item.field}</td>
                                  <td>{item.oldValue}</td>
                                  <td>{item.newValue}</td>
                                  <td className="d-flex">
                                    <RenderTimeLineButton
                                      auditObjectLogId={item.auditObjectLogId}
                                      fieldId={item.fieldId}
                                      field={item.field}
                                    />
                                    <RenderObjectLogButton
                                      auditObjectLogId={item.auditObjectLogId}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <tr>
                              <td className="text-center" colSpan={100}>
                                <p>{localization.noRecordFound}</p>
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <AuditFieldLog fieldLogInfo={fieldLog} />
      <AuditObjectLog
        auditObjectLogId={objectLog}
        closeAuditObjectLog={handleCloseAuditObjectLog}
      />
    </>
  );
}

export default Audit;
